<div class="loader" *ngIf="loading">
	<div class="spinner spinner-bubble spinner-bubble-primary me-3"></div>
</div>
